<!-- @veltra/icons generated sha256:ac5e9c6490c739de gen:8 source:src/svg/normal/vertical-align-right.svg -->
<script setup lang="ts">
defineOptions({ name: 'VerticalAlignRight' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2.506 3h10.988A.51.51 0 0 0 14 2.496.507.507 0 0 0 13.494 2H2.506A.51.51 0 0 0 2 2.504c0 .268.23.496.506.496m2.99 3.5h8.008a.5.5 0 0 0 0-1H5.496a.5.5 0 0 0 0 1m8.008 7H5.496a.5.5 0 0 1 0-1h8.008a.5.5 0 0 1 0 1M2.506 10h10.988A.51.51 0 0 0 14 9.496.507.507 0 0 0 13.494 9H2.506A.51.51 0 0 0 2 9.504c0 .268.23.496.506.496"
    />
  </svg>
</template>
